import React, {useEffect, useState} from 'react'
import {useHorses} from '../../hooks/useHorses'
import {get, orderBy} from 'lodash'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../store'
import {TUser} from '../../shared/types/user.type'
import {Box, Button, Card, CardContent, Typography} from '@mui/material'
import HorsesLoaderSkeleton from '../horses/HorsesLoaderSkeleton'
import Horses from '../horses/Horses'
import {TTrainerHorse} from '../../shared/types/trainerHorse.type'
import {setHorseModal, setHorseToEdit} from '../../store/reducers/modal.reducer'
import {t} from 'i18next'
import {Add} from '@mui/icons-material'
import {routes} from '../../pages/routes'
import {Link} from 'react-router-dom'

function HorsesCard() {
    const auth = useSelector<RootState>(state => state.user.user) as TUser | null
    const isUserLoading = useSelector<RootState>(state => state.user.isUserLoading) as boolean
    const dispatch = useDispatch()

    const {
        horses,
        isLoadingHorses,
        changeHorseStatus,
        isHorseUpdating
    } = useHorses(!isUserLoading || false, get(auth, '@id'), {
        horses: {
            itemsPerPage: 12,
            [encodeURIComponent("order[in-training-first]")]: 'DESC',
        }
    })
    const [filteredHorses, setFilteredHorses] = useState<TTrainerHorse[]>([])

    const handleHorseEdit = (horse: TTrainerHorse) => {
        dispatch(setHorseToEdit(horse.horse))
        openHorseModal()
    }


    const openHorseModal = () => {
        dispatch(setHorseModal(true))
    }


    const onInputChange = (id: number, checked: boolean) => {
        changeHorseStatus(id, {horse_in_training: checked})
    }

    useEffect(() => {
        setFilteredHorses(orderBy(horses, i => !i.horse_in_training, 'asc'))
    }, [horses])

    const addHorse = () => {

        dispatch(setHorseToEdit(null))
        dispatch(setHorseModal(true))
    }

    return (
        <Card>
            <CardContent>
                <Box mb={2} display={'flex'} justifyContent={'space-between'} alignItems={'center'} gap={2}>
                    <Typography variant='h5'>{t('horses')}</Typography>
                    <Button onClick={addHorse} startIcon={<Add/>} variant='outlined'>{t('dashboard:addHorse')}</Button>
                </Box>
                <Box maxHeight={'320px'} overflow={'auto'} position={'relative'}>
                    {
                        isLoadingHorses ? <HorsesLoaderSkeleton></HorsesLoaderSkeleton> :
                            <Horses onEdit={handleHorseEdit} onChange={onInputChange} horses={filteredHorses}></Horses>
                    }
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        position: 'sticky',
                        bottom: 0,
                        zIndex: 10,
                        padding: 3
                    }} className='infinite-bg'>
                        <Button component={Link} to={routes.DASHBOARD_ROUTES.YARD}
                                disabled={isLoadingHorses}>{t('seeMore')}</Button>
                    </div>
                </Box>


            </CardContent>
        </Card>
    )
}

export default HorsesCard